import React, { useMemo, useState } from "react";
import "./NewRequestLine.scss";

const SEEN_KEY = "bls-form-requests-seen-ids";

const readSeen = () => {
  try {
    const value = JSON.parse(localStorage.getItem(SEEN_KEY) || "[]");
    return Array.isArray(value) ? value.map(Number) : [];
  } catch (error) {
    return [];
  }
};

const writeSeen = (ids) => {
  try {
    localStorage.setItem(SEEN_KEY, JSON.stringify(ids.slice(-200)));
  } catch (error) {
    return false;
  }
  return true;
};

export const isWaitingRequest = (ad) =>
  Number(ad?.IsFilledByClient) === 1 && Number(ad?.IsReadyToReview) === 1;

export const unseenRequests = (items, seenIds) =>
  (items || [])
    .filter(isWaitingRequest)
    .filter((ad) => !(seenIds || []).includes(Number(ad.Want_ad_Id)))
    .sort((a, b) => Number(b.Want_ad_Id) - Number(a.Want_ad_Id));

const nameOf = (ad) => String(ad?.RequesterName || "").trim();

export const requestHeadline = (fresh) => {
  if (fresh.length === 1) {
    const name = nameOf(fresh[0]);
    return (
      <>
        New request from {name || "your Buyer Listing Form"}:{" "}
        <strong>{fresh[0].Title_Text}</strong>
      </>
    );
  }
  const names = [...new Set(fresh.map(nameOf).filter(Boolean))];
  const from =
    names.length === 0
      ? "from your Buyer Listing Form"
      : names.length === 1
        ? `from ${names[0]}`
        : names.length === 2
          ? `from ${names[0]} and ${names[1]}`
          : `from ${names[0]}, ${names[1]} and ${names.length - 2} more`;
  return (
    <>
      <strong>{fresh.length} new requests</strong> {from}
    </>
  );
};

const NewRequestLine = ({ items, onReviewOne }) => {
  const [seenIds, setSeenIds] = useState(readSeen);
  const fresh = useMemo(() => unseenRequests(items, seenIds), [items, seenIds]);
  if (!fresh.length) return null;

  const review = () => {
    const next = fresh[0];
    const updated = [...seenIds, Number(next.Want_ad_Id)];
    writeSeen(updated);
    setSeenIds(updated);
    onReviewOne(next.Want_ad_Id);
  };

  const dismiss = () => {
    const updated = [...seenIds, ...fresh.map((ad) => Number(ad.Want_ad_Id))];
    writeSeen(updated);
    setSeenIds(updated);
  };

  return (
    <section className="new-request-line" aria-live="polite">
      <p className="new-request-line__text">{requestHeadline(fresh)}</p>
      <div className="new-request-line__actions">
        <button type="button" className="new-request-line__review" onClick={review}>
          {fresh.length === 1 ? "Review" : "Review newest"}
        </button>
        <button type="button" className="new-request-line__close" aria-label="Dismiss" onClick={dismiss}>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <path d="M2 2l10 10M12 2 2 12" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
          </svg>
        </button>
      </div>
    </section>
  );
};

export default NewRequestLine;
